import React from 'react';
import { Link } from 'react-router-dom';
import { COMPANY_INFO } from '../data/company';

export function Footer() {
  return (
    <footer className="bg-[#0B0E14] text-white">
      <div className="mx-auto grid max-w-[1640px] grid-cols-1 gap-12 px-5 py-16 sm:px-8 lg:grid-cols-[1.15fr_.8fr_1fr] lg:gap-24 lg:px-12 lg:py-22">
        <section>
          <h2 className="text-2xl font-semibold">Firmainfo</h2>
          <div className="mt-6 space-y-1 font-serif text-sm leading-7 text-white/65">
            <p>{COMPANY_INFO.name}</p>
            <p>{COMPANY_INFO.address}, {COMPANY_INFO.city}</p>
          </div>
          <div className="mt-8 space-y-2 font-serif text-sm text-white/65">
            <p>Telefon: <a className="text-[#206FEA] transition hover:text-white" href={`tel:${COMPANY_INFO.phoneRaw}`}>{COMPANY_INFO.phone}</a></p>
            <p>E-mail: <a className="text-[#206FEA] transition hover:text-white" href={`mailto:${COMPANY_INFO.email}`}>{COMPANY_INFO.email}</a></p>
            <p>CVR: {COMPANY_INFO.cvr}</p>
          </div>
          <div className="mt-6">
            <a
              href="https://www.facebook.com/Jnomontage"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm text-white/80 transition hover:text-[#1877F2]"
            >
              <i className="fa-brands fa-facebook text-lg text-[#1877F2]" aria-hidden="true" />
              <span>Følg os på Facebook</span>
            </a>
          </div>
        </section>
        <section>
          <h2 className="text-2xl font-semibold">Menu</h2>
          <nav className="mt-6 flex flex-col items-start gap-3 font-serif text-sm text-white/65">
            <Link to="/ydelser/service" className="transition hover:text-[#a8ad68]">Service</Link>
            <Link to="/ydelser/luft-til-vand-varmepumpe" className="transition hover:text-[#a8ad68]">Luft til vand</Link>
            <Link to="/ydelser/luft-til-luft-varmepumpe" className="transition hover:text-[#a8ad68]">Luft til luft</Link>
            <Link to="/prisberegner" className="transition hover:text-[#a8ad68]">Priser</Link>
            <Link to="/kontakt" className="transition hover:text-[#a8ad68]">Kontakt</Link>
            <a href="https://www.iubenda.com/privacy-policy/37357290" className="iubenda-white iubenda-noiframe iubenda-embed transition hover:text-[#a8ad68]" title="Privatlivspolitik ">Privatlivspolitik</a>
            <a href="https://www.iubenda.com/privacy-policy/37357290/cookie-policy" className="iubenda-white iubenda-noiframe iubenda-embed transition hover:text-[#a8ad68]" title="Cookiepolitik ">Cookiepolitik</a>
          </nav>
        </section>
        <section>
          <h2 className="text-2xl font-semibold">Kontakt os i dag</h2>
          <p className="mt-6 max-w-md font-serif text-sm leading-7 text-white/65">Vi står klar til at rådgive om energiløsninger, installation og service. Kontakt os for et uforpligtende tilbud eller svar på dine spørgsmål.</p>
          <Link to="/kontakt" className="mt-7 inline-flex items-center gap-3 rounded-xl bg-[#206FEA] px-6 py-3 text-sm font-semibold text-white transition hover:bg-[#206FEA]/85">Kontakt os <i className="fa-light fa-arrow-right" aria-hidden="true" /></Link>
        </section>
      </div>
    </footer>
  );
}
